import { autoinject, bindable, observable, BindingEngine, Disposable } from 'aurelia-framework';
import { RequiredDimensionValue } from "./linked-mappings-service";
import { IDimension } from './service-targeting';

@autoinject
export class AccountingDimensionSelect {
	@bindable dimensions: IDimension[];
	@bindable dimensionModel: RequiredDimensionValue;
	@bindable fiscalYearId: string;
	@bindable modelChanged: (condition: RequiredDimensionValue) => void;

	@observable selectedDimension: IDimension;

	private dimensionValueSubscriber: Disposable;

	constructor(private bindingEngine: BindingEngine) {
	}

	selectedDimensionChanged(): void {
		this.dimensionModel.dimensionId = this.selectedDimension.id;
	}

	dimensionValueChanged(): void {
		if (this.modelChanged && this.dimensionModel.dimensionId && this.dimensionModel.dimensionValueId) {
			this.modelChanged(this.dimensionModel);
		}
	}

	attached() {
		this.dimensionValueSubscriber = this.bindingEngine
			.propertyObserver(this.dimensionModel, "dimensionValueId")
			.subscribe(this.dimensionValueChanged.bind(this));
	}

	detached() {
		if(this.dimensionValueSubscriber) {
			this.dimensionValueSubscriber.dispose();
		}
	}
}
